import { CardData } from './card-data';
import { Variant } from '../product/dto/variant';
import { ProductType } from '../enum/dto/product-type.enum';
import { VariantTypeUtils } from '../../utils/variant-type-utils';
import { memoize } from '../../modules/shared/decorators/memoize';
import {
  SectionColumnConfigDataForCannabinoidsAndTerpenesColumn,
  SectionColumnConfigDataValue
} from '../enum/shared/section-column-config-data-value';
import { CompoundUtils } from '../../utils/compound-utils';
import { VariantBadge } from '../product/dto/variant-badge';
import { BadgeUtils } from '../../utils/badge-utils';
import { FilterUtils } from '../../utils/filter-utils';

export class PlantlifeSharedCardData extends CardData {
  public override getSize(variant?: Variant): string {
    const v = variant || this.rowVariants?.firstOrNull();
    if (v?.packagedQuantity > 1) {
      const formattedUnitSize = v?.getFormattedUnitSize();
      switch (v?.productType) {
        case ProductType.Beverage:
        case ProductType.Concentrate:
        case ProductType.Flower:
        case ProductType.Vape:
        case ProductType.Wellness:
          return `${v?.packagedQuantity} x ${formattedUnitSize}`;
        case ProductType.Oil: {
          if (!VariantTypeUtils.isCapsuleType(v?.variantType)) {
            return `${v?.packagedQuantity} x ${formattedUnitSize}`;
          }
          break;
        }
        case ProductType.Other: {
          if (VariantTypeUtils.isOtherTypeWithCannabinoids(v?.variantType)) {
            return `${v?.packagedQuantity} x ${formattedUnitSize}`;
          }
          break;
        }
      }
    }
    return super.getSize(variant);
  }

  @memoize
  protected override getCannabinoidAsString(
    cannabinoid: string,
    units: string,
    displayFormat: SectionColumnConfigDataValue = SectionColumnConfigDataForCannabinoidsAndTerpenesColumn.NumericValue,
    fixedPoint?: number,
    variant?: Variant
  ): string {
    const parsedCannabinoid = this.getMinRowCannabinoid(cannabinoid, variant);
    switch (true) {
      case displayFormat === SectionColumnConfigDataForCannabinoidsAndTerpenesColumn.PresenceIcon: {
        return parsedCannabinoid > 0 ? '✔' : '-';
      }
      case !Number.isFinite(parsedCannabinoid):
      case parsedCannabinoid < CompoundUtils.smallestAllowableValue: {
        return '-';
      }
      case Number.isFinite(fixedPoint): {
        const fixed = parsedCannabinoid.toFixed(fixedPoint);
        return `${fixed}${this.getCannabinoidFormatedUnitOfMeasureString(units)}`.trim();
      }
      default: {
        const rounded = Math.round((parsedCannabinoid + Number.EPSILON) * 100) / 100;
        return `${rounded}${this.getCannabinoidFormatedUnitOfMeasureString(units)}`.trim();
      }
    }
  }

  @memoize
  override getAllVariantBadges(): VariantBadge[] {
    const sectionType = this.section?.layoutType;
    const variantBadgeMap = this.section?.variantBadgeMap;
    const scopedVisibleVariants = this.getScopedVisibleVariants();
    const badges = BadgeUtils.getBadges(sectionType, 0, variantBadgeMap, scopedVisibleVariants);
    const limit = this.menu?.getAllowedBadgeCount();
    return badges?.filter(badge => FilterUtils.removeBadgesWith86Keyword(badge))?.take(limit);
  }
}
